import { Component, OnInit, Input } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'app-imovel-pf',
  templateUrl: './imovel-pf.component.html',
  styleUrls: ['./../cadastral-pf/cadastral-pf.component.css','./imovel-pf.component.css']
})
export class ImovelPfComponent implements OnInit {

  @Input() dados:any;
  public txtButtonConsultar:string='Consultar agora';
  public consultando:Boolean=false;
  public naoSolicitou:Boolean=false;
  public naoEncontrouRegistros:Boolean=false;
  public modalRef:BsModalRef;

  constructor(private modalService:BsModalService) { }
  

  ngOnInit() {
    if(this.dados.imovel===undefined){
      this.naoSolicitou=true;
    }else if(this.dados.imovel===null){
      this.naoEncontrouRegistros=true;
    }
  }

}
